import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme:Theme) => ({
    select:{
        width:250,
    },
    marginBottom10: {
        marginBottom:10
      },
    formControl: {
    minWidth:240,
    },
    total:{ marginLeft: 15,paddingTop:12,fontWeight:'bold'},
    label:{
        fontSize:16,
        paddingTop:22
    },
}));